module.exports = __webpack_public_path__ + "img/1366302-52-4.5daf3aac.png";